import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import LandingPage from "../pages/public/LandingPage/LandingPage";
import NotFoundPage from "../pages/public/error/NotFoundPage";
import UnauthorizedPage from "../pages/public/error/UnauthorizedPage";
import LoginPage from "../pages/public/AuthPages/LoginPage";
import InstitutionsPage from "../pages/public/InstitutionDetailsPage/InstitutionDetailsPage";
import CustomerProfilePage from "../pages/customer/profile-page/ProfilePage";
import CustomerLayout from "../layouts/CustomerLayout";
import PublicLayout from "../layouts/PublicLayout";
import AdminLayout from "../layouts/AdminLayout";
import AppointmentsPage from "../pages/customer/appointments-page/AppointmentsPage";
import AdminDashboard from "../pages/admin/AdminDashboard";
import ManageBranches from "../pages/admin/ManageBranches";
import ManageEmployees from "../pages/admin/ManageEmployees";
import TurnDetailsPage from "../pages/customer/queue-turn-details-page/queue-turn-details-page";
import AppointmentDetailsPage from "../pages/customer/appointment-details-page/appointment-details-page";
import CustomerSignupPage from "../pages/public/AuthPages/customer/CustomerSignupPage";
import EmployeeDashboard from "../pages/employee/employee-dashboard-page/employee-dashboard-page";
import InstitutionDetailsPage from "../pages/public/InstitutionDetailsPage/InstitutionDetailsPage";
import EmployeeLayout from "../layouts/EmployeeLayout";
import QueueDetailsPage from "../pages/employee/queue-details-page";

import ManageServices from "../pages/admin/ManageServices";
import ManageAppointments from "../pages/employee/service-details-page";
import QueueMetricsPage from "../pages/admin/queue-metrics";
import InstitutionSignupPage from "../pages/public/AuthPages/admin/InstitutionSignupPage";
import CompleteRegistration from "../pages/employee/complete-registration";
import InstitutionSettingsPage from "../pages/admin/InstitutionSettings";

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Pages */}
            <Route
                path="/"
                element={
                    <PublicLayout />
                }>
                <Route index element={<Navigate to="/landing" replace />} />
                <Route path="/landing" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<InstitutionSignupPage />} />
                <Route path="/institutions" element={<InstitutionsPage />} />
                <Route path="/unauthorized" element={<UnauthorizedPage />} />

                {/* these links shared by the institution owner ---> for customer use */}
                <Route path="/institution/:institutionID" element={<InstitutionDetailsPage />} />

                {/* these links sent to customer using whatsapp, to see details */}
                <Route path="/reservation/:turnID" element={<TurnDetailsPage />} />
                <Route path="/appointment/:appointmentID" element={<AppointmentDetailsPage />} />
                <Route path="/not-found" element={<NotFoundPage />} />
                <Route path="*" element={<NotFoundPage />} />

                {/* this link sent to employee to complete registration */}
                <Route path="/complete-registration/:token" element={<CompleteRegistration/>}/>

            </Route>


            {/* Customer Routes */}
            <Route element={<ProtectedRoutes allowedRoles={['customer']} />}>
                <Route path="/customer" element={<CustomerLayout />}>
                    <Route index element={<Navigate to="/customer/appointments" replace />} />
                    <Route path="/customer/profile" element={<CustomerProfilePage />} />
                    <Route path="/customer/appointments" element={<AppointmentsPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Route>


            {/* Employee Routes */}
            <Route element={<ProtectedRoutes allowedRoles={['employee']} />}>
                <Route path="/employee" element={<EmployeeLayout />}>
                    <Route index element={<Navigate to="/employee/dashboard" replace />} />
                    <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
                    <Route path="/employee/queue/:queueId" element={<QueueDetailsPage />} />;
                    <Route path="/employee/service/:serviceId" element={<ManageAppointments />} />;
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Route>



            <Route element={<ProtectedRoutes allowedRoles={['admin']} />}>
                <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<Navigate to="/admin/dashboard" replace />} />
                    <Route path="/admin/dashboard" element={<QueueMetricsPage />} />
                    <Route path="/admin/manage-branches" element={<ManageBranches />} />
                    <Route path="/admin/manage-employees" element={<ManageEmployees />} />
                    <Route path="/admin/manage-services" element={<ManageServices />} />
                    <Route path="/admin/manage-settings" element={<InstitutionSettingsPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Route>
            <Route path="*" element={<NotFoundPage />} />

        </Routes>
    );
};

export default AppRoutes;
